module.exports = __webpack_public_path__ + "img/836.99688369.png";